/**
 * Common Translations Module (French)
 * Matches English structure exactly
 * @module common
 * @language fr
 */

export const common = {
  nav: {
    // 1. Overview (standalone)
    overview: "Aperçu",
    
    // 2. Youth Futures (dropdown parent)
    youthFutures: "Futurs de la Jeunesse",
    // Youth Futures dropdown items
    impactMetrics: "Impact et Métriques",
    mentalHealth: "Dimension Santé Mentale",
    workforceEducation: "Main-d'œuvre et Éducation",
    entrepreneurshipSupport: "Dimension Entrepreneuriat",
    
    // 3. Database (dropdown parent)
    database: "Base de Données",
    // Database dropdown items
    memberInsights: "Perspectives des Membres",
    programsEvents: "Programmes et Événements",
    technologyFuture: "Technologie et Futur",
    regionalAnalysis: "Analyse Régionale",
    
    // 4. Vision 2040 (standalone)
    vision2040: "Vision 2040",
    
    // 5. Know More (dropdown parent)
    knowMore: "En Savoir Plus",
    // Know More dropdown items
    methodology: "Méthodologie",
    contributing: "Contribuer",
    faq: "FAQ",
    
    // Additional nav items
    backToTop: "Retour en haut",
    brandName: "JCI Vision Pulse",
    observatoryTitle: "Observatoire des Futurs de la Jeunesse",
    developmentCouncils: "Conseils de Développement"
  },
  footer: {
    copyright: "© 2025 Conseils de Développement JCI. Sous licence CC BY-NC-SA.",
    methodology: "Méthodologie basée sur les données de 147.424 membres JCI dans le monde.",
    poweredBy: "Propulsé par",
    privacyPolicy: "Politique de Confidentialité",
    termsOfService: "Conditions d'Utilisation"
  },
  settings: {
    title: "Paramètres",
    subtitle: "Gérez vos préférences et personnalisez votre expérience.",
    appearance: "Apparence",
    appearanceDescription: "Personnalisez l'apparence de l'observatoire sur votre appareil.",
    light: "Clair",
    dark: "Sombre",
    system: "Système",
    language: "Langue",
    languageDescription: "Sélectionnez votre langue préférée pour l'interface.",
    notifications: "Notifications",
    notificationsDescription: "Configurez comment vous souhaitez recevoir les mises à jour et alertes.",
    emailNotifications: "Notifications par Email",
    emailNotificationsDescription: "Recevez des mises à jour et des rapports par email.",
    pushNotifications: "Notifications Push",
    pushNotificationsDescription: "Recevez des alertes en temps réel dans votre navigateur.",
    productUpdates: "Mises à jour Produit",
    productUpdatesDescription: "Restez informé des nouvelles fonctionnalités et améliorations.",
    preferencesUpdated: "Préférences mises à jour",
    notificationsEnabled: "notifications activées",
    notificationsDisabled: "notifications désactivées",
    themeUpdated: "Thème mis à jour",
    themeChangedTo: "Thème changé en",
    languageUpdated: "Langue mise à jour",
    languageChangedTo: "Langue changée en",
    profile: "Votre Profil",
    profileDescription: "Informations de votre compte",
    clickToChangeAvatar: "Cliquez sur l'avatar pour changer",
    avatar: {
      error: "Erreur",
      loginRequired: "Vous devez être connecté pour télécharger un avatar",
      invalidType: "Type de fichier invalide",
      selectImage: "Veuillez sélectionner un fichier image",
      tooLarge: "Image trop grande",
      selectSmaller: "Veuillez sélectionner une image plus petite (max 100Ko après compression)",
      updated: "Avatar mis à jour",
      updatedSuccess: "Votre photo de profil a été mise à jour avec succès",
      uploadFailed: "Échec du téléchargement",
      failedToUpload: "Impossible de télécharger l'avatar"
    },
    observatoryLens: "Lentille de l'Observatoire",
    observatoryLensDescription: "Vos préférences de focus de données personnalisées",
    primaryInterest: "Intérêt Principal",
    focusCountry: "Pays de Focus",
    refineLens: "Affiner la Lentille de l'Observatoire",
    translationDebug: "Débogueur de Traduction",
    translationDebugDescription: "Voir les clés de traduction manquantes et le statut de complétion",
    dangerZone: "Zone de Danger",
    dangerZoneDescription: "Actions irréversibles affectant votre compte",
    deleteAccount: "Supprimer le Compte",
    deleteAccountDescription: "Supprimer définitivement votre compte et toutes les données associées",
    deleteAccountConfirmTitle: "Supprimer votre compte ?",
    deleteAccountConfirmDescription: "Cette action ne peut pas être annulée. Toutes vos données seront définitivement supprimées, y compris :",
    deleteAccountDataProfile: "Vos informations de profil",
    deleteAccountDataNotifications: "Préférences et historique des notifications",
    deleteAccountDataAvatar: "Votre photo de profil",
    deleteAccountDataProgress: "Progression et réalisations de l'observatoire",
    typeEmailConfirm: "Tapez votre email pour confirmer :",
    deleteAccountButton: "Supprimer Mon Compte Définitivement",
    accountDeleted: "Compte Supprimé",
    accountDeletedDescription: "Votre compte et toutes les données associées ont été définitivement supprimés.",
    deleteFailed: "Échec de la Suppression",
    deleteFailedDescription: "Impossible de supprimer votre compte. Veuillez réessayer ou contacter le support.",
    emailMismatch: "L'email ne correspond pas",
    // Privacy & Data Export
    privacyData: "Confidentialité et Données",
    privacyDataDescription: "Gérez vos données personnelles et paramètres de confidentialité",
    downloadData: "Télécharger Vos Données",
    downloadDataDescription: "Exportez toutes vos données personnelles au format JSON (profil, notifications, préférences)",
    downloadAsJson: "Télécharger en JSON",
    downloading: "Préparation du téléchargement...",
    downloadComplete: "Téléchargement Terminé",
    downloadCompleteDescription: "Vos données personnelles ont été téléchargées avec succès.",
    downloadFailed: "Échec du Téléchargement",
    downloadFailedDescription: "Impossible d'exporter vos données. Veuillez réessayer.",
    cancel: "Annuler",
    // Data Processing Record - GDPR Article 30
    processingRecord: {
      title: "Registre des Traitements de Données",
      activitiesRecorded: "activités de traitement enregistrées",
      view: "Voir le Registre",
      hide: "Masquer le Registre",
      noActivities: "Aucune activité de traitement enregistrée pour le moment",
      legalBasisLabel: "Base Légale",
      showMore: "Afficher {{count}} de plus",
      showLess: "Afficher moins",
      gdprNote: "Conformément à l'Article 30 du RGPD, vous avez le droit d'accéder aux registres de toutes les activités de traitement de données sur votre compte.",
      activityTypes: {
        accountCreated: "Compte créé",
        profileUpdated: "Informations de profil mises à jour",
        onboardingCompleted: "Intégration terminée",
        achievementUnlocked: "Réalisation débloquée",
        preferencesCreated: "Préférences de notification définies",
        preferencesUpdated: "Préférences de notification mises à jour",
        notificationSent: "Notification envoyée",
        notificationRead: "Notification lue",
        roleAssigned: "Rôle attribué"
      },
      legalBasis: {
        consent: "Consentement",
        contractPerformance: "Exécution du contrat",
        legitimateInterest: "Intérêt légitime"
      }
    }
  },
  progress: {
    title: "Maîtrise de l'Observatoire",
    description: "Suivez votre parcours à travers l'Observatoire",
    emailVerified: "Email vérifié",
    visitedModules: "Visité",
    modules: "modules",
    setupComplete: "Configuration terminée",
    observer: "Observateur",
    analyst: "Analyste",
    visionary: "Visionnaire"
  },
  notifications: {
    title: "Notifications",
    empty: "Aucune notification",
    viewSettings: "Paramètres de Notification",
    markAllRead: "Tout marquer comme lu",
    preferences: "Préférences de Notification",
    preferencesDescription: "Contrôlez comment vous recevez les briefings de renseignement",
    emailAlerts: "Alertes Email",
    emailAlertsDescription: "Recevez les Briefings Stratégiques de Renseignement par email",
    inAppAlerts: "Alertes In-App",
    inAppAlertsDescription: "Afficher les notifications toast lors de la connexion",
    weeklyDigest: "Résumé Hebdomadaire",
    weeklyDigestDescription: "Recevez un résumé de renseignement chaque semaine",
    intelBriefing: "📊 Nouvelles Informations Disponibles",
    deleteAll: "Tout Supprimer",
    deleteAllConfirm: "Supprimer Toutes les Notifications?",
    deleteAllDescription: "Cela supprimera définitivement tout votre historique de notifications. Cette action est irréversible.",
    deleteAllButton: "Supprimer Toutes les Notifications",
    deleted: "Notifications supprimées",
    deletedDescription: "Toutes vos notifications ont été définitivement supprimées.",
    deleteError: "Échec de la suppression",
    deleteErrorDescription: "Impossible de supprimer les notifications. Veuillez réessayer.",
    cancel: "Annuler",
    deletedSingle: "Notification supprimée",
    swipeHint: "Glissez vers la gauche pour supprimer"
  },
  roles: {
    admin: "Administrateur",
    administrator: "Administrateur",
    moderator: "Modérateur",
    user: "Utilisateur",
  },
  interests: {
    "mental health": "Santé Mentale",
    "mental-health": "Santé Mentale",
    "workforce preparation": "Préparation au Travail",
    "workforce-preparation": "Préparation au Travail",
    "entrepreneurship": "Entrepreneuriat",
    "technology adoption": "Adoption Technologique",
    "technology-adoption": "Adoption Technologique",
    "regional analysis": "Analyse Régionale",
    "regional-analysis": "Analyse Régionale",
  },
  mastery: {
    observer: "Observateur",
    analyst: "Analyste",
    visionary: "Visionnaire",
  },
  visibility: {
    membersOnly: "MEMBRES UNIQUEMENT",
    adminOnly: "ADMIN UNIQUEMENT",
    hiddenAdminOnly: "CACHÉ (admin uniquement)",
  },
  admin: {
    sendBriefing: "Envoyer Briefing de Renseignement",
    sendBriefingDescription: "Envoyez un Briefing Stratégique de Renseignement aux utilisateurs abonnés",
    module: "Module",
    selectModule: "Sélectionnez un module",
    briefingTitle: "Titre",
    titlePlaceholder: "Ex: Nouvelles Données de Santé Mentale Publiées",
    summary: "Résumé",
    summaryPlaceholder: "Brève description du nouveau renseignement...",
    sendToSubscribers: "Envoyer aux Abonnés",
    recipientNote: "Les destinataires sont les utilisateurs avec un intérêt principal correspondant qui ont les alertes email activées",
    fillAllFields: "Veuillez remplir tous les champs",
    briefingSent: "Briefing Envoyé",
    sentTo: "Envoyé à",
    subscribers: "abonnés",
    sendFailed: "Échec de l'envoi du briefing",
    briefingSentTo: "Briefing envoyé à",
    users: "utilisateurs",
    sending: "Envoi en cours...",
    // API Key Management
    apiKeys: {
      title: "Clés API",
      description: "Gérez les clés API pour l'accès externe aux données YFI",
      create: "Créer une Clé API",
      createTitle: "Créer une Nouvelle Clé API",
      createDescription: "Créez une nouvelle clé API pour permettre à un logiciel externe d'accéder à l'API de données YFI.",
      name: "Nom",
      namePlaceholder: "Ex: Mon Application",
      keyDescription: "Description",
      descriptionPlaceholder: "À quoi servira cette clé ?",
      expiration: "Expiration",
      never: "N'expire jamais",
      days30: "30 jours",
      days90: "90 jours",
      months6: "6 mois",
      year1: "1 an",
      cancel: "Annuler",
      creating: "Création...",
      created: "Clé API Créée",
      createdDescription: "Votre nouvelle clé API a été créée. Copiez-la maintenant - elle ne sera plus affichée.",
      saveKeyWarning: "Sauvegardez votre clé API maintenant !",
      saveKeyDescription: "C'est la seule fois où vous verrez cette clé. Copiez-la et stockez-la en sécurité.",
      savedKey: "J'ai sauvegardé ma clé",
      revoke: "Révoquer",
      revokeTitle: "Révoquer la Clé API",
      revokeDescription: "Êtes-vous sûr de vouloir révoquer cette clé ? Cette action est irréversible. Les applications utilisant cette clé perdront immédiatement l'accès.",
      revoking: "Révocation...",
      revoked: "Clé API Révoquée",
      revokedDescription: "La clé API a été révoquée et ne peut plus être utilisée.",
      noKeys: "Aucune clé API pour l'instant",
      noKeysDescription: "Créez votre première clé API pour commencer.",
      active: "Active",
      expired: "Expirée",
      created_at: "Créée",
      lastUsed: "Dernière utilisation",
      requests: "requêtes",
      viewDocs: "Consultez le Guide d'Intégration API pour la documentation sur l'utilisation de ces clés.",
      failedToLoad: "Échec du chargement des clés API",
      failedToCreate: "Échec de la création de la clé API",
      failedToRevoke: "Échec de la révocation de la clé API"
    },
    // Data Administration
    dataAdmin: {
      title: "Administration des Données",
      description: "Surveillez et gérez les données de l'observatoire",
      refresh: "Actualiser",
      coverage: "Couverture des Profils Pays",
      coverageDescription: "des pays ont des profils détaillés",
      databaseTables: "Tables de Base de Données",
      yfiCountries: "Pays YFI",
      yfiCountriesDesc: "Pays avec scores YFI",
      countryProfiles: "Profils Pays",
      countryProfilesDesc: "Données détaillées par pays",
      jciStats: "Statistiques JCI",
      jciStatsDesc: "Métriques organisationnelles globales",
      regions: "Régions",
      regionsDesc: "Régions JCI",
      activeApiKeys: "Clés API Actives",
      activeApiKeysDesc: "Accès logiciel externe",
      apiRequests: "Requêtes API",
      apiRequestsDesc: "Total des requêtes enregistrées",
      countryProfilesTitle: "Profils Pays",
      published: "publiés",
      draft: "Brouillon",
      updated: "Mis à jour",
      noProfiles: "Aucun profil pays créé pour l'instant",
      quickActions: "Actions Rapides",
      viewYfiRankings: "Voir Classements YFI",
      regionalAnalysis: "Analyse Régionale",
      backendNote: "Pour la gestion avancée de la base de données, accédez au panneau Lovable Cloud depuis les paramètres du projet."
    }
  },
  featuredInsight: {
    title: "Votre Pays Cible",
    fiiScore: "Indice d'Impact Futur",
    globalAverage: "Moyenne Mondiale",
    viewFullRankings: "Voir l'Indice Complet",
    unlockTitle: "Débloquez Vos Insights Personnalisés",
    unlockDescription: "Complétez la configuration pour voir comment votre pays cible se compare à la moyenne mondiale sur toutes les dimensions du YFI."
  },
  header: {
    title: "Observatoire des Futurs de la Jeunesse des Conseils de Développement JCI",
    subtitle: "Observatoire Mondial des Conseils de Développement",
    tagline: "Développer des Leaders pour un Monde en Évolution"
  },
  common: {
    jan: "Jan",
    feb: "Fév",
    mar: "Mar",
    apr: "Avr",
    may: "Mai",
    jun: "Jun",
    jul: "Jul",
    aug: "Aoû",
    sep: "Sep",
    oct: "Oct",
    nov: "Nov",
    dec: "Déc",
    preferredProgramTypes: "Types de Programme Préférés",
    preferredEventFormat: "Format d'Événement Préféré",
    regionalPreferences: "Préférences Régionales",
    inPerson: "En Personne",
    online: "En Ligne",
    hybrid: "Hybride",
    networking: "Réseautage",
    development: "Développement",
    leadership: "Leadership",
    search: "Rechercher",
    settings: "Paramètres",
    signIn: "Se Connecter",
    signOut: "Se Déconnecter",
    toggleMenu: "Basculer menu de navigation",
    scrollToTop: "Défiler vers le haut",
    source: "Source",
    sources: {
      membership2025: "Adhésion JCI 2025",
      impactReport2025: "Rapport d'Impact JCI 2025"
    },
    loading: "Chargement...",
    noDataAvailable: "Données non disponibles",
    noDataDescription: "Les données sont en cours de chargement ou ne sont pas disponibles actuellement.",
    errorLoadingChart: "Erreur de chargement du graphique",
    months: {
      jan: "Jan",
      feb: "Fév",
      mar: "Mar",
      apr: "Avr",
      may: "Mai",
      jun: "Jun",
      jul: "Jul",
      aug: "Aoû",
      sep: "Sep",
      oct: "Oct",
      nov: "Nov",
      dec: "Déc"
    }
  },
  ui: {
    notFound: {
      title: "404",
      message: "Oups! Page non trouvée",
      returnHome: "Retour à l'Accueil"
    },
    keyboardShortcuts: {
      title: "Raccourcis Clavier",
      toggleDarkMode: "Basculer mode sombre/clair",
      cycleLanguages: "Changer de langues",
      openSearch: "Ouvrir la recherche",
      showShortcuts: "Afficher raccourcis clavier",
      ctrlOrCmd: "Utilisez Ctrl sur Windows/Linux ou ⌘ sur Mac"
    },
    commandPalette: {
      searchPlaceholder: "Rechercher des pages...",
      noResults: "Aucun résultat trouvé.",
      pagesHeading: "Pages"
    },
    languageToggle: {
      selectLanguage: "Sélectionner la langue",
      changeLanguage: "Changer de langue"
    }
  },
  charts: {
    noDataAvailable: "Données non disponibles",
    dataLoadingSoon: "Les données se chargeront bientôt",
    noFunnelData: "Données d'entonnoir non disponibles",
    configureProcessData: "Configurer les données du processus",
    radarUnavailable: "Données radar non disponibles",
    configurePerformanceIndicators: "Configurer indicateurs de performance",
    performanceUnavailable: "Données de performance non disponibles",
    configureTrendData: "Configurer données de tendance",
    currentProgress: "Progrès Actuel",
    goal2040: "Objectif 2040",
    mainValue: "Valeur Principale",
    trend: "Tendance",
    goal: "Objectif",
    fiiScore: "Score YFI",
    score: "Score",
    value: "Valeur",
    percentage: "Pourcentage",
    region: "Région",
    country: "Pays",
    members: "Membres",
    year: "Année",
    month: "Mois",
    count: "Nombre",
    total: "Total",
    current: "Actuel",
    projected: "Projeté",
    average: "Moyenne"
  },
  metrics: {
    membersActive: "Membres Actifs",
    countriesPresent: "Pays Présents",
    startupsSupported: "Startups Soutenues",
    sustainableProjects: "Projets Durables",
    completed: "complété",
    countries: "Pays",
    members: "Membres",
    projects: "Projets",
    projectsPerYear: "Projets/an",
    memberDensity: "Densité des Membres",
    country: "Pays",
    regionalDistribution: "Distribution Régionale",
    globalPresence: "Présence mondiale de JCI en 2025",
    activeMembers: "Membres Actifs",
    globally: "dans le monde",
    worldwidePresence: "présence mondiale",
    communities: "Communautés",
    activeCommunities: "communautés actives",
    yearsOfHistory: "Années d'Histoire",
    since1915: "depuis 1915",
    vs2024: "vs 2024",
    annualProjects: "Projets Annuels",
    in2025: "en 2025"
  },
  index: {
    heroTitle: "Observatoire des Futurs de la Jeunesse des Conseils de Développement JCI",
    heroSubtitle: "Mesurer le Leadership Jeune, la Santé Mentale et l'Opportunité Économique Mondialement",
    heroDescription: "Une plateforme basée sur les données analysant les conditions pour les jeunes leaders dans 114 pays.",
    globalImpactTitle: "Impact Mondial en un Coup d'Œil",
    verifiedData: "Données vérifiées du Rapport d'Impact JCI 2025",
    globalMembers: "Membres Mondiaux",
    activeWorldwide: "Actifs dans le monde",
    projects: "Projets",
    period20242025: "Période: 2024-2025",
    volunteerHours: "Heures de Bénévolat",
    hoursContributed: "Heures contribuées",
    countries: "Pays",
    worldwidePresence: "Présence mondiale",
    localOrganizations: "Organisations Locales",
    activeCommunities: "Communautés actives",
    digitalReachTitle: "Portée et Empreinte Numérique",
    totalFollowers: "Abonnés Totaux",
    jciccUsers: "Utilisateurs jci.cc",
    memberDemographicsTitle: "Instantané de la Démographie des Membres",
    averageAge: "Âge Moyen",
    yearsOld: "Ans",
    universityEducated: "Éducation Universitaire",
    bachelorsOrHigher: "Licence ou supérieur",
    fullTime: "Temps plein",
    entrepreneurs: "Entrepreneurs",
    employmentStatus: "Statut d'Emploi"
  },
  globalPresenceMap: {
    title: "Présence Mondiale JCI",
    subtitle: "Actif dans {{count}} Pays à travers 4 Régions",
    regions: "régions",
    countries: "pays",
    source: "Source: Rapport d'Impact JCI 2025"
  },
  mentalHealth: {
    serviceGapNote: "Écart de couverture des services de 30-40% entre États-Unis/Canada et Amérique Latine",
    criticalGapNote: "Écart critique: seulement 10-30% de couverture des services vs 70%+ en Europe"
  },
  memberInsights: {
    npsTitle: "Net Promoter Score",
    npsBreakdown: "Répartition NPS",
    memberProfile: "Profil des Membres JCI",
    surveyInfo: "Enquête sur l'Expérience des Membres 2025 • {{count}} répondants de toutes les régions",
    averageAge: "Âge Moyen",
    ageRange: "Tranche: 18-40",
    universityEducated: "Éducation Universitaire",
    degreesHeldPursuing: "Diplômes obtenus ou en cours",
    entrepreneurs: "Entrepreneurs",
    selfEmployedMembers: "Membres indépendants",
    surveyRespondents: "Répondants à l'Enquête",
    allAreas: "Toutes les 4 Zones JCI",
    ageGroupAnalysis: "Analyse par Groupe d'Âge",
    coreAgeGroup: "Cœur 28-40 ans: {{percent}}%",
    years: "ans",
    ofMembers: "des membres",
    challenges: "Défis",
    strengths: "Forces",
    careerEntry: "Entrée en Carrière",
    financialIndependence: "Indépendance Financière",
    educationBalance: "Équilibre Éducatif",
    digitalNative: "Digital Native",
    freshPerspective: "Perspective Nouvelle",
    enthusiasm: "Enthousiasme",
    avgAgeByRegion: "Âge Moyen par Région",
    youngest: "Le Plus Jeune",
    oldest: "Le Plus Âgé",
    membershipTenureAnalysis: "Analyse de l'Ancienneté",
    alumniNetwork: "Réseau des Anciens",
    generationalContinuity: "Continuité générationnelle par le mentorat",
    alumniClubs: "Clubs d'Anciens",
    nations: "Nations",
    avgStay: "Séjour Moyen",
    transitionNote: "Transition aux Anciens à 40+ ans",
    tenureInsight: "Aperçu: 53% de nouveaux membres (1-3 ans) apportent une énergie nouvelle tandis que 24% de vétérans (7+ ans) fournissent un leadership et une stabilité essentiels",
    leadershipProgression: "Progression de Leadership",
    majority: "Majorité",
    localChapterLeaders: "Leaders d'Organisations Locales",
    foundationOfJCI: "Fondation de JCI",
    educationalAttainment: "Niveau d'Éducation",
    bachelorsDegree: "Licence",
    mastersDegree: "Master",
    mastersEnrolled: "Master (Inscrit)",
    phdPursuing: "Doctorat en Cours",
    technicalVocational: "Technique/Professionnel",
    universityDegreeNote: "97%+ des membres JCI détiennent ou poursuivent des diplômes universitaires",
    industryDiversity: "Diversité des Industries",
    primarySectorsNote: "Principaux secteurs représentés par les membres JCI",
    education: "Éducation",
    technology: "Technologie",
    finance: "Finance",
    healthcare: "Santé",
    nonprofit: "Sans But Lucratif",
    government: "Gouvernement",
    manufacturing: "Industrie",
    services: "Services",
    motivationsValues: "Motivations et Valeurs des Membres",
    whatDrivesEngagement: "Ce qui motive l'engagement des membres JCI",
    motivationsBenefits: "Motivations et Avantages des Membres",
    understandingEngagement: "Comprendre ce qui motive l'engagement des membres JCI",
    source: "Source",
    memberExperienceSurvey: "Enquête sur l'Expérience des Membres",
    whyMembersJoin: "Pourquoi les Membres Rejoignent JCI",
    personalDevelopment: "Développement Personnel",
    growthThroughExperience: "Croissance par l'expérience et les projets",
    leadershipOpportunities: "Opportunités de Leadership",
    accessToRoles: "Accès aux rôles et postes de leadership",
    professionalNetworking: "Réseautage Professionnel",
    buildingConnections: "Développer des connexions professionnelles",
    communityService: "Service Communautaire",
    positiveImpact: "Créer un impact positif dans les communautés",
    mostValuedBenefits: "Avantages les Plus Valorisés",
    leadershipDevelopment: "Développement du Leadership",
    structuredPrograms: "Programmes de développement structurés",
    accessToTraining: "Accès à la Formation et Certifications",
    professionalWorkshops: "Ateliers et cours professionnels",
    globalNetworkConnections: "Réseau Mondial et Connexions",
    connectionsAcrossRegions: "Connexions à travers les régions et les pays",
    impactOpportunities: "Opportunités d'Impact",
    meaningfulChange: "Opportunités de créer un changement significatif",
    topSkillsToDevelop: "Compétences Prioritaires à Développer",
    rankedByInterest: "Classées par niveau d'intérêt des membres",
    memberSkillsSurveySource: "Source: Enquête sur l'Expérience des Membres JCI 2025",
    communicationPublicSpeaking: "Communication et Prise de Parole",
    priority: "Priorité",
    publicSpeakingPrograms: "Programmes de prise de parole et débat",
    viewPrograms: "Voir les Programmes",
    associatedPrograms: "Programmes Associés",
    publicSpeakingCompetition: "Concours de Prise de Parole",
    debatingChampionship: "Championnat de Débat",
    viewProgramsEvents: "Voir Programmes et Événements",
    keyInsightsTitle: "Principales Conclusions de l'Enquête sur l'Expérience des Membres 2025",
    memberPriorities: "Priorités des Membres",
    memberPriority1: "La croissance personnelle est la motivation principale (28%)",
    memberPriority2: "Le développement du leadership stimule l'engagement (24%)",
    memberPriority3: "Accent fort sur le réseautage et les connexions (21%)",
    memberPriority4: "L'engagement pour le service communautaire reste essentiel (17%)",
    valueProposition: "Proposition de Valeur",
    valueProp1: "JCI répond aux attentes de développement du leadership",
    valueProp2: "Les programmes de formation sont très valorisés (24%)",
    valueProp3: "L'accès au réseau mondial est un différenciateur clé",
    valueProp4: "Les membres recherchent des opportunités d'impact tangible",
    regionalMemberDistribution: "Distribution Régionale des Membres",
    clickToExplore: "Cliquez sur une région pour explorer les détails"
  },
  onboarding: {
    commandCenterSetup: "Configuration du Centre de Commande",
    stepOf: "Étape {{current}} sur {{total}}",
    continue: "Continuer",
    back: "Retour",
    completeSetup: "Terminer la Configuration",
    preferencesUpdated: "Préférences Mises à Jour",
    lensUpdated: "Votre lentille d'observatoire a été mise à jour.",
    error: "Erreur",
    saveFailed: "Impossible d'enregistrer vos préférences. Veuillez réessayer.",
    identity: {
      title: "Confirmez Votre Identité",
      description: "Dites-nous qui vous êtes et à quelle organisation JCI vous appartenez.",
      fullName: "Nom Complet",
      fullNamePlaceholder: "Entrez votre nom complet",
      nationalOrg: "Organisation Nationale JCI",
      nationalOrgPlaceholder: "Sélectionnez votre organisation nationale...",
      searchCountry: "Rechercher un pays...",
      noCountryFound: "Aucun pays trouvé.",
      localOrg: "Organisation Locale JCI",
      optional: "Optionnel",
      localOrgPlaceholder: "Ex: JCI Paris, JCI Lyon"
    },
    lens: {
      title: "Choisissez Votre Lentille",
      description: "Sélectionnez votre domaine d'intérêt principal. Cela personnalisera votre expérience sur le tableau de bord.",
      mentalHealth: "Santé Mentale",
      mentalHealthDesc: "Concentrez-vous sur le bien-être psychologique, la résilience et les initiatives de santé mentale.",
      education: "Éducation et Main-d'œuvre",
      educationDesc: "Explorez les résultats d'apprentissage, le développement des compétences et les tendances de l'emploi.",
      entrepreneurship: "Entrepreneuriat",
      entrepreneurshipDesc: "Découvrez la santé de l'écosystème des affaires, l'activité des startups et les métriques d'innovation."
    },
    benchmark: {
      title: "Définissez Votre Benchmark",
      description: "Choisissez un pays de focus à comparer avec la Moyenne Globale du YFI dans tout le tableau de bord.",
      focusCountry: "Pays de Focus",
      focusCountryPlaceholder: "Sélectionnez votre pays de focus...",
      searchCountry: "Rechercher un pays...",
      noCountryFound: "Aucun pays trouvé.",
      vsGlobal: "{{country}} vs Moyenne Globale",
      globalAverage: "Moyenne Globale",
      aboveAverage: "+{{value}} au-dessus de la moyenne globale",
      belowAverage: "-{{value}} en dessous de la moyenne globale"
    },
    config: {
      ready: "Prêt à Lancer !",
      configuring: "Configuration de Votre Centre de Commande",
      step1: "Analyse de vos préférences...",
      step2: "Configuration de la mise en page du tableau de bord...",
      step3: "Chargement des insights personnalisés...",
      step4: "Préparation de votre Centre de Commande..."
    }
  },
  fiiClassifications: {
    excellent: "Excellent",
    good: "Bon",
    moderate: "Modéré",
    deficient: "Insuffisant",
    critical: "Critique"
  },
  regions: {
    asiaPacific: "Asie et le Pacifique",
    europe: "Europe",
    americas: "Amérique",
    africaMiddleEast: "Afrique et Moyen-Orient"
  },
  access: {
    exclusiveMemberInsight: "Insight Exclusif pour Membres",
    adminOnlyModule: "Module Administrateurs Uniquement",
    joinCTA: "Rejoignez l'Observatoire des Futurs de la Jeunesse des Conseils de Développement JCI pour débloquer la base de données complète, les insights et les projections.",
    adminOnlyMessage: "Ce contenu {{moduleLabel}} est disponible uniquement pour les administrateurs.",
    joinNowLogin: "Rejoindre Maintenant / Connexion",
    backToDashboard: "Retour au Tableau de Bord",
    memberAccess: "Accès Membre",
    passwordlessEntry: "Accès sans mot de passe avec Magic Link ou Google.",
    joinObservatory: "Rejoignez l'Observatoire",
    unlockDescription: "Débloquez des insights exclusifs aux membres, des projections et des modules interactifs.",
    email: "E-mail",
    emailPlaceholder: "vous@entreprise.com",
    sendMagicLink: "Envoyer le Magic Link",
    continueWithGoogle: "Continuer avec Google",
    authDisclaimer: "En continuant, vous acceptez de recevoir des e-mails d'authentification.",
    signingIn: "Connexion en cours...",
    checkInbox: "Vérifiez votre boîte de réception",
    magicLinkSent: "Nous vous avons envoyé un lien magique sécurisé pour vous connecter.",
    invalidEmail: "E-mail invalide",
    invalidEmailDescription: "Veuillez entrer une adresse e-mail valide.",
    loginFailed: "Échec de la connexion",
    googleLoginFailed: "Échec de la connexion Google"
  },
  errorBoundary: {
    title: "Une erreur s'est produite",
    description: "Nous nous excusons pour le désagrément. Une erreur inattendue s'est produite.",
    tryAgain: "Réessayer",
    goHome: "Aller à l'accueil",
    errorDetails: "Détails de l'erreur (Développement uniquement)",
    helpText: "Si ce problème persiste, veuillez actualiser la page ou contacter le support.",
    chunkLoadError: {
      title: "Échec du Chargement de la Page",
      description: "La page n'a pas pu être chargée. Cela peut être dû à un problème réseau ou à un cache obsolète.",
      retry: "Réessayer",
      retryMessage: "Tentative {{current}} sur {{max}}",
      maxRetries: "Nombre maximum de tentatives atteint."
    }
  },
  chatJCI: {
    title: "ChatJCI",
    openChat: "Ouvrir le chat",
    closeChat: "Fermer le chat",
    placeholder: "Tapez votre question...",
    send: "Envoyer le message",
    thinking: "Réflexion...",
    greeting: "Bonjour, {{name}}! Comment puis-je vous aider aujourd'hui?",
    defaultName: "vous",
    fallbackMessage: "Désolé, je n'ai pas pu trouver cette information dans ma base de connaissances.",
    errorMessage: "Désolé, quelque chose s'est mal passé. Veuillez réessayer.",
    rateLimitMessage: "Trop de demandes. Veuillez attendre un moment avant de réessayer.",
    authRequired: "Veuillez vous connecter pour utiliser ChatJCI.",
    welcomeSubtitle: "Posez-moi vos questions sur les programmes JCI, l'adhésion ou la Vision 2040",
    newChat: "Nouvelle Conversation",
    poweredBy: "Propulsé par Google Gemini",
    suggestedPrompts: {
      title: "Essayez de demander :",
      vision2040: "Qu'est-ce que la Vision 2040 de JCI ?",
      risePrograms: "Parlez-moi des programmes JCI RISE",
      membership: "Comment devenir membre de JCI ?",
      councils: "Quels sont les Conseils de Développement ?",
      youthIndex: "Expliquez l'Indice des Futurs de la Jeunesse"
    },
    loginRequired: {
      title: "Connectez-vous pour Chatter",
      description: "ChatJCI est réservé aux membres JCI. Connectez-vous pour démarrer une conversation.",
      action: "Se Connecter"
    },
    locked: {
      title: "Assistant IA Réservé aux Membres",
      description: "ChatJCI est votre guide IA personnel pour les programmes JCI, la Vision 2040 et l'Indice des Futurs de la Jeunesse. Connectez-vous pour démarrer une conversation."
    },
    sidebar: {
      newChat: "Nouvelle Conversation",
      today: "Aujourd'hui",
      yesterday: "Hier",
      last7Days: "7 Derniers Jours",
      older: "Plus Ancien",
      noConversations: "Aucune conversation",
      searchPlaceholder: "Rechercher des conversations...",
      noResults: "Aucune conversation trouvée",
      deleteConversation: "Supprimer la conversation ?",
      deleteConfirmation: "Cela supprimera définitivement cette conversation et tous ses messages.",
      delete: "Supprimer",
      renameConversation: "Renommer",
      exportAll: "Exporter Toutes les Conversations"
    },
    export: {
      asJson: "Exporter en JSON",
      asMarkdown: "Exporter en Markdown",
      downloading: "Préparation du téléchargement...",
      success: "Conversations exportées",
      singleSuccess: "Conversation exportée",
      successDescription: "Votre historique de chat a été téléchargé avec succès",
      error: "Échec de l'exportation",
      errorDescription: "Impossible d'exporter les conversations. Veuillez réessayer.",
      noConversations: "Aucune conversation à exporter"
    },
    copy: {
      tooltip: "Copier dans le presse-papiers",
      success: "Conversation copiée",
      successDescription: "Markdown copié dans le presse-papiers. Collez n'importe où !",
      error: "Échec de la copie",
      errorDescription: "Impossible de copier dans le presse-papiers. Veuillez réessayer."
    },
    share: {
      button: "Partager",
      dialogTitle: "Partager la Conversation",
      dialogDescription: "Toute personne disposant de ce lien peut voir cette conversation.",
      copyLink: "Copier le Lien",
      linkCopied: "Lien copié !",
      revokeShare: "Révoquer le Partage",
      shareRevoked: "Lien de partage révoqué",
      createError: "Impossible de créer le lien de partage",
      generating: "Génération du lien...",
      expiresLabel: "Le lien expire",
      never: "Jamais",
      viewCount: "{{count}} vues",
      expiresAt: "Expire le {{date}}",
      expirationLabel: "Le lien expire dans",
      days7: "7 jours",
      days30: "30 jours",
      days90: "90 jours"
    },
    sharedView: {
      title: "Conversation ChatJCI Partagée",
      sharedBy: "Partagé par un Membre JCI",
      sharedOn: "Partagé le {{date}}",
      signUpCta: "Vous voulez votre propre assistant IA ?",
      signUpButton: "S'inscrire à ChatJCI",
      notFound: "Conversation introuvable",
      notFoundDescription: "Ce lien partagé a peut-être expiré ou a été révoqué.",
      expired: "Ce lien partagé a expiré"
    },
    message: {
      copy: "Copier",
      copied: "Copié !",
      regenerate: "Régénérer",
      edit: "Modifier",
      stopGenerating: "Arrêter",
      editPlaceholder: "Modifiez votre message...",
      cancel: "Annuler",
      saveAndSubmit: "Sauvegarder et Envoyer"
    },
    streaming: {
      generating: "Génération...",
      stopped: "Arrêté"
    }
  },
  gdpr: {
    cookieTitle: "Préférences de Cookies",
    cookieDescription: "Nous utilisons des cookies pour analyser l'utilisation du site et améliorer votre expérience. Vos données ne sont jamais vendues à des tiers.",
    learnMore: "En savoir plus sur nos pratiques de confidentialité",
    accept: "Accepter",
    decline: "Refuser",
    analyticsTitle: "Analytics et Cookies",
    analyticsDescription: "Gérez comment nous utilisons les cookies et analytics pour améliorer votre expérience",
    allowAnalytics: "Autoriser Analytics",
    allowAnalyticsDescription: "Aidez-nous à améliorer en partageant des données d'utilisation anonymes",
    analyticsEnabled: "Analytics Activé",
    analyticsEnabledDescription: "Vous pouvez maintenant nous aider à améliorer la plateforme avec des données d'utilisation anonymes.",
    analyticsDisabled: "Analytics Désactivé",
    analyticsDisabledDescription: "Vos données d'utilisation ne seront plus collectées.",
    whatWeCollect: "Ce que nous collectons :",
    collectItem1: "Vues de pages et modèles de navigation",
    collectItem2: "Engagement des fonctionnalités et profondeur de défilement",
    collectItem3: "Informations anonymes sur l'appareil et le navigateur",
    neverCollect: "Nous ne collectons jamais d'informations personnelles et ne vendons pas vos données à des tiers."
  },
  apiDocs: {
    badge: "API Développeur",
    hero: {
      title: "API de l'Observatoire des Futurs de la Jeunesse",
      subtitle: "Accédez aux données complètes sur le développement des jeunes de 114 pays. Créez des applications, des visualisations et intégrez les métriques YFI dans vos projets.",
      getAccess: "Obtenir l'Accès API",
      viewDocs: "Voir la Spécification OpenAPI"
    },
    stats: { countries: "Pays", statistics: "Statistiques", endpoints: "Points de Terminaison" },
    features: {
      badge: "Pourquoi Utiliser Notre API",
      title: "Conçu pour les Développeurs",
      subtitle: "Notre API fournit un accès fiable et bien documenté aux métriques complètes de développement des jeunes.",
      sampleRequest: "Exemple de Requête",
      restful: { title: "API RESTful JSON", description: "Points de terminaison REST standard retournant des réponses JSON propres et prévisibles." },
      filtering: { title: "Filtrage Complet", description: "Filtrez les données par région, classification, plages de scores et plus encore.", highlight: "15+ Filtres" },
      pagination: { title: "Pagination et Tri", description: "Gérez efficacement de grands ensembles de données avec pagination intégrée.", highlight: "Basé sur Offset" },
      auth: { title: "Clés API Sécurisées", description: "Clés hachées SHA-256 avec limites de taux par clé." },
      logging: { title: "Journalisation des Requêtes", description: "Analytics complet de l'utilisation de votre API.", highlight: "Analytics" },
      cors: { title: "CORS Activé", description: "Requêtes cross-origin supportées nativement." }
    },
    auth: {
      badge: "Sécurité",
      title: "Authentification",
      subtitle: "Toutes les requêtes API nécessitent une authentification par clé API.",
      step1: { title: "Obtenez Votre Clé API", description: "Naviguez vers Paramètres et générez une nouvelle clé API." },
      step2: { title: "Ajoutez aux En-têtes", description: "Incluez votre clé API dans l'en-tête X-API-Key." },
      step3: { title: "Commencez à Construire", description: "Vous êtes prêt ! Faites des requêtes à n'importe quel point de terminaison." },
      headerExample: "Format d'En-tête"
    },
    endpoints: {
      badge: "Référence API",
      title: "Points de Terminaison Disponibles",
      subtitle: "Cinq points de terminaison puissants pour accéder à toutes les données YFI.",
      parameters: "Paramètres de Requête",
      sampleRequest: "Exemple de Requête",
      sampleResponse: "Exemple de Réponse",
      yfi: { title: "Classements YFI", description: "Accédez aux scores et classements du Youth Futures Index pour tous les pays." },
      countries: { title: "Profils de Pays", description: "Données détaillées par pays incluant démographie et présence JCI." },
      stats: { title: "Statistiques Globales", description: "Statistiques agrégées JCI incluant comptage des membres." },
      indicators: { title: "Métadonnées des Indicateurs", description: "Obtenez des définitions détaillées, méthodologies et seuils pour tous les indicateurs YFI. Aucune authentification requise." },
      benchmarks: { title: "Benchmarks Régionaux", description: "Benchmarks statistiques par région incluant moyenne, médiane, percentiles et pays les plus performants." }
    },
    params: {
      yfi: { region: "Filtrer par région JCI", classification: "Filtrer par niveau YFI", code: "Obtenir un pays spécifique par code ISO", sort: "Champ de tri", order: "Direction du tri: asc ou desc", limit: "Résultats par page", offset: "Offset de pagination", countryCodes: "Filtrer plusieurs pays par codes ISO séparés par virgule", fields: "Retourner uniquement des champs spécifiques" },
      countries: { slug: "Identifiant du profil du pays" },
      stats: { key: "Obtenir une statistique spécifique", category: "Filtrer par catégorie" },
      indicators: { key: "Filtrer par clé d'indicateur spécifique", category: "Filtrer par catégorie d'indicateur", lang: "Code de langue pour noms/descriptions traduits" },
      benchmarks: { region: "Code de région pour benchmarks régionaux", indicator: "Indicateur spécifique pour benchmark", top: "Nombre de pays les plus performants à inclure" }
    },
    table: { parameter: "Paramètre", type: "Type", description: "Description" },
    responseFormat: {
      title: "Format de Réponse",
      subtitle: "Tous les points de terminaison retournent une structure JSON cohérente.",
      structure: "Structure de Réponse Standard",
      success: { title: "Tableau de Données", description: "Les résultats sont retournés dans le champ 'data'." },
      meta: { title: "Métadonnées Incluses", description: "Chaque réponse inclut info de pagination et ID de requête." }
    },
    errors: {
      title: "Gestion des Erreurs",
      subtitle: "L'API utilise des codes de statut HTTP standard.",
      "401": { title: "Non Autorisé", description: "Clé API manquante, invalide ou révoquée." },
      "404": { title: "Non Trouvé", description: "La ressource demandée n'existe pas." },
      "405": { title: "Méthode Non Autorisée", description: "Seules les requêtes GET sont supportées." },
      "429": { title: "Limite de Taux Dépassée", description: "Vous avez dépassé votre limite de taux." },
      "500": { title: "Erreur Serveur", description: "Une erreur inattendue s'est produite." }
    },
    useCases: {
      title: "Cas d'Utilisation",
      subtitle: "Découvrez comment les organisations utilisent les données YFI.",
      research: { title: "Recherche Académique", description: "Universités utilisent les données YFI pour des études comparatives." },
      journalism: { title: "Journalisme de Données", description: "Organisations de presse créent des visualisations impactantes." },
      ngo: { title: "Planification ONG", description: "Organisations utilisent les insights régionaux pour planifier." },
      policy: { title: "Analyse de Politiques", description: "Agences gouvernementales analysent les métriques YFI." }
    },
    quickStart: { title: "Démarrage Rapide", subtitle: "Faites votre première requête API en quelques secondes." },
    copy: "Copier",
    copied: "Copié !",
    codeCopied: "Code copié dans le presse-papiers",
    copyFailed: "Échec de la copie du code",
    cta: { title: "Prêt à Construire ?", subtitle: "Générez votre clé API et commencez à construire aujourd'hui. Aucune carte de crédit requise.", button: "Obtenir Votre Clé API" }
  }
} as const;
